import z from "zod";

export const GestaoEpiSchema = z.object({
  idGestaoEpi: z.number().optional().nullable(),
  nome: z.string().nonempty('Este campo deve ser preenchido!'),
  especificacao: z.string().optional().nullable(),
  ativo: z.number().optional().nullable().default(1),
});


export type GestaoEpiForm = z.infer<typeof GestaoEpiSchema>;